"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6062],{

/***/ 50641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SwiperCardWithBannerDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16606);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74627);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30706);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73165);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62009);
/* harmony import */ var components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90894);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ ////////////////// AKA: Two Columns Swiper Banner in inititive/temp4 template //////////////////



// Import Swiper React components

// Import Swiper styles



// import required modules




function SwiperCardWithBannerDescription(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), swiper = ref21[0], setSwiper = ref21[1];
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEnd = ref22[0], setIsEnd = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBeginning = ref23[0], setIsBeginning = ref23[1];
    var handleSwiperUpdate = function(swiper) {
        setSwiper(swiper);
        // check if at end or at beginneg
        swiper.on("slideChange", function() {
            if (swiper.isEnd) {
                setIsEnd(true);
            } else {
                setIsEnd(false);
            }
            if (swiper.isBeginning) {
                setIsBeginning(true);
            } else {
                setIsBeginning(false);
            }
        });
    };
    var componentId = "".concat(props === null || props === void 0 ? void 0 : props.SectionId, "-").concat(props === null || props === void 0 ? void 0 : props.sectionIx).trim().replace(/ /g, "-");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // Optional: attach listener once only
            swiper.on("slideChange", function() {
                setIsBeginning(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: "py-10 bg-neutral-100 w-full relative ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " relative z-10 ",
                children: [
                    ((props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value) || (props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Description) === null || ref3 === void 0 ? void 0 : ref3.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex responsive flex-col gap-5",
                        children: [
                            (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Title) === null || ref5 === void 0 ? void 0 : ref5.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-[30px] font-bold animate-top-dga",
                                id: "template-carousel-title-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                                children: props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Title) === null || ref7 === void 0 ? void 0 : ref7.value
                            }),
                            (props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Description) === null || ref9 === void 0 ? void 0 : ref9.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "template-carousel-desc-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                                className: "animate-top-dga overflow-hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                    field: props === null || props === void 0 ? void 0 : (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : ref10.Description
                                })
                            })
                        ]
                    }),
                    (props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Items) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(swiper ? "opacity-100" : "opacity-0", " transition-opacity md:responsive ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-[5%] " : "ml-[5%] ", " duration-500 pt-10"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                            onInit: function(ev) {
                                setSwiper(ev);
                                if (ev.isEnd) {
                                    setIsEnd(true);
                                } else {
                                    setIsEnd(false);
                                }
                                if (ev.isBeginning) {
                                    setIsBeginning(true);
                                } else {
                                    setIsBeginning(false);
                                }
                            },
                            onSwiper: function(e) {
                                handleSwiperUpdate(e);
                            // check end and beginner
                            },
                            slidesPerView: 1.2,
                            spaceBetween: 16,
                            breakpoints: {
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 24
                                }
                            },
                            pagination: {
                                clickable: true,
                                el: "#".concat(componentId)
                            },
                            freeMode: true,
                            modules: [
                                swiper__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl,
                                swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5
                            ],
                            a11y: {
                                enabled: true,
                                paginationBulletMessage: "Go to slide {{index}}"
                            },
                            dir: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "rtl" : "ltr",
                            className: "mySwiper !p-[1px]",
                            children: (props === null || props === void 0 ? void 0 : (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Items) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && (props === null || props === void 0 ? void 0 : (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Items) === null || ref16 === void 0 ? void 0 : ref16.map(function(point, index) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                                var ref18, ref19;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                                    className: "w-full !h-auto overflow-hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: " animate-top-dga overflow-hidden w-full rounded-2xl h-full border border-neutral-300 p-4 flex bg-white flex-col gap-5 items-center",
                                        children: [
                                            (point === null || point === void 0 ? void 0 : (ref = point.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Icon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-[48px] bg-neutral-100 rounded-full relative w-[48px] mx-auto",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                    unoptimized: true,
                                                    src: point === null || point === void 0 ? void 0 : (ref3 = point.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Icon) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.src,
                                                    alt: ((ref18 = point === null || point === void 0 ? void 0 : (ref6 = point.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Icon) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.alt) !== null && ref18 !== void 0 ? ref18 : "").trim() || ((ref19 = point === null || point === void 0 ? void 0 : (ref9 = point.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Title) === null || ref10 === void 0 ? void 0 : ref10.value) !== null && ref19 !== void 0 ? ref19 : "").trim() || "Banner icon",
                                                    layout: "fill",
                                                    objectFit: "contain"
                                                })
                                            }),
                                            (point === null || point === void 0 ? void 0 : (ref11 = point.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Title) === null || ref12 === void 0 ? void 0 : ref12.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-lg font-bold",
                                                children: point === null || point === void 0 ? void 0 : (ref13 = point.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Title) === null || ref14 === void 0 ? void 0 : ref14.value
                                            }),
                                            (point === null || point === void 0 ? void 0 : (ref15 = point.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Description) === null || ref16 === void 0 ? void 0 : ref16.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                                id: "section-point-" + (props === null || props === void 0 ? void 0 : props.SectionId) + "-" + index,
                                                className: "",
                                                field: point === null || point === void 0 ? void 0 : (ref17 = point.fields) === null || ref17 === void 0 ? void 0 : ref17.Description
                                            })
                                        ]
                                    })
                                }, index);
                            }))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: componentId,
                className: "md:hidden custom_swiper !mt-8 mx-auto !justify-center"
            }),
            (props === null || props === void 0 ? void 0 : (ref17 = props.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.Items) === null || ref18 === void 0 ? void 0 : ref18.length) > 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "responsive mt-8 hidden md:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "\n        ".concat(swiper ? "opacity-100" : "opacity-0", "\n        w-fit\n        ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-auto" : "ml-auto", "\n        flex-row gap-4\n        hidden\n        ").concat((props === null || props === void 0 ? void 0 : (ref19 = props.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.Items) === null || ref20 === void 0 ? void 0 : ref20.length) > 2 ? "md:flex" : "md:hidden", "\n      "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                            direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "right" : "left",
                            onClick: function() {
                                swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                handleSwiperUpdate(swiper);
                            },
                            size: "large",
                            disabled: isBeginning,
                            style: "primary"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                            direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "left" : "right",
                            onClick: function() {
                                swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                handleSwiperUpdate(swiper);
                            },
                            size: "large",
                            disabled: isEnd,
                            style: "primary"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 34852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TemplateDownloadIcon": function() { return /* binding */ TemplateDownloadIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var VARIANT_COLORS = {
    black: "#161616",
    grey: "#6C737F",
    white: "#FFFFFF"
};
var TemplateDownloadIcon = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "black" : _variant, color = param.color, _size = param.size, size = _size === void 0 ? 24 : _size, _className = param.className, className = _className === void 0 ? "" : _className, ariaLabel = param["aria-label"];
    var fillColor = color !== null && color !== void 0 ? color : VARIANT_COLORS[variant];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        "aria-label": ariaLabel,
        "aria-hidden": !ariaLabel,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.7502 4C12.7502 3.58579 12.4145 3.25 12.0002 3.25C11.586 3.25 11.2502 3.58579 11.2502 4V12.4619L11.2442 12.4548C11.0335 12.2061 10.8272 11.9434 10.6343 11.6976L10.5896 11.6407C10.3973 11.396 10.1951 11.1388 10.0381 10.9773C9.74935 10.6802 9.27453 10.6735 8.9775 10.9622C8.68048 11.2509 8.67373 11.7257 8.96243 12.0227C9.05114 12.114 9.19676 12.2958 9.40995 12.5672L9.45699 12.6271C9.64705 12.8693 9.87005 13.1534 10.0998 13.4245C10.346 13.715 10.6216 14.0168 10.897 14.2515C11.0351 14.369 11.1907 14.485 11.3581 14.5746C11.5195 14.661 11.742 14.75 12.0002 14.75C12.2585 14.75 12.481 14.661 12.6424 14.5746C12.8098 14.485 12.9654 14.369 13.1035 14.2515C13.3789 14.0168 13.6545 13.715 13.9007 13.4245C14.1304 13.1534 14.3534 12.8694 14.5434 12.6272L14.5905 12.5672C14.8037 12.2958 14.9494 12.114 15.0381 12.0227C15.3268 11.7257 15.32 11.2509 15.023 10.9622C14.726 10.6735 14.2511 10.6802 13.9624 10.9773C13.8054 11.1388 13.6031 11.396 13.4109 11.6407L13.3662 11.6977C13.1733 11.9434 12.967 12.2062 12.7563 12.4548L12.7502 12.4619V4Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.7074 14.2496C21.8453 13.859 21.6404 13.4306 21.2498 13.2928C20.8592 13.1549 20.4308 13.3598 20.293 13.7504L20.0591 14.413C19.5984 15.7184 19.2725 16.6385 18.9379 17.3282C18.6116 18.0007 18.3082 18.3853 17.9296 18.6531C17.551 18.921 17.0874 19.0791 16.3446 19.1629C15.5829 19.2489 14.6068 19.25 13.2224 19.25H10.778C9.39359 19.25 8.41753 19.2489 7.65581 19.1629C6.91303 19.0791 6.44937 18.921 6.0708 18.6531C5.69224 18.3853 5.38882 18.0007 5.06254 17.3282C4.72794 16.6385 4.40204 15.7184 3.94129 14.413L3.70745 13.7504C3.56959 13.3598 3.14119 13.1549 2.75059 13.2928C2.35999 13.4306 2.1551 13.859 2.29296 14.2496L2.54175 14.9545C2.98414 16.208 3.33715 17.2082 3.71299 17.9829C4.10137 18.7834 4.54467 19.4108 5.20444 19.8776C5.86422 20.3444 6.60339 20.5536 7.48754 20.6535C8.34313 20.75 9.40382 20.75 10.7331 20.75H13.2673C14.5966 20.75 15.6573 20.75 16.5129 20.6535C17.397 20.5536 18.1362 20.3444 18.796 19.8776C19.4557 19.4108 19.899 18.7834 20.2874 17.9829C20.6633 17.2082 21.0163 16.208 21.4587 14.9545L21.7074 14.2496Z",
                fill: fillColor
            })
        ]
    });
};


/***/ }),

/***/ 3848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17163);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87664);
/* harmony import */ var _TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34852);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_util_href_download_handling__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83616);
/* harmony import */ var src_hooks_useTrackedHrefDownload__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73775);







function TemplateNavigation1(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34;
    var cta = (0,src_hooks_useTrackedHrefDownload__WEBPACK_IMPORTED_MODULE_6__/* .useTrackedHrefDownload */ .o)(props.locale, "mocHome");
    var scrollTopFunction = function(value) {
        if (value) {
            var element = document.getElementById(value);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }
    };
    var onDownloadFile = function() {
        var ref, ref1;
        return void cta.handleMediaFieldDownload(props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.DownloadBtnFile) === null || ref1 === void 0 ? void 0 : ref1.value);
    };
    var handleNavLinkClick = function(rawHref, target) {
        if (!rawHref) return;
        void cta.handleHref(rawHref, target);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(props === null || props === void 0 ? void 0 : props.locale, "  pt-8 pb-6"),
        style: {
            background: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.NavigationBackgroundColor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive w-full grid grid-cols-12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-wrap gap-5 !align-baseline items-center col-span-12 md:col-span-10",
                    style: {
                        alignItems: "baseline !important"
                    },
                    children: [
                        (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ShowLinksAtEnd) === null || ref5 === void 0 ? void 0 : ref5.value) && (props === null || props === void 0 ? void 0 : (ref6 = props.ScrollTo) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && (props === null || props === void 0 ? void 0 : (ref7 = props.ScrollTo) === null || ref7 === void 0 ? void 0 : ref7.map(function(link, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                onClick: function() {
                                    return scrollTopFunction(link === null || link === void 0 ? void 0 : link.SectionId);
                                },
                                style: {
                                    color: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.NavigationTextColor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value,
                                    fontFamily: (ref6 = props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.NavigationTextFont) === null || ref5 === void 0 ? void 0 : ref5.fields.Title) === null || ref6 === void 0 ? void 0 : ref6.value
                                },
                                className: "cursor-pointer !border-none md:!text-[14px] !text-[10px] ",
                                children: link === null || link === void 0 ? void 0 : link.ScrollToText
                            }, index);
                        })),
                        Array.isArray(props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : ref8.Links) && (props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Links) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && (props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Links) === null || ref12 === void 0 ? void 0 : ref12.map(function(link, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
                            var rawHref = link === null || link === void 0 ? void 0 : (ref = link.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.ButtonUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.href;
                            var navStyle = {
                                color: props === null || props === void 0 ? void 0 : (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.NavigationTextColor) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Title) === null || ref6 === void 0 ? void 0 : ref6.value,
                                fontFamily: props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.NavigationTextFont) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Title) === null || ref10 === void 0 ? void 0 : ref10.value
                            };
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cursor-pointer ",
                                children: rawHref && (0,src_util_href_download_handling__WEBPACK_IMPORTED_MODULE_5__/* .hrefIsTrackedFileDownload */ .P)(rawHref) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    style: navStyle,
                                    className: "border-none md:!text-[14px] !text-[10px] !flex !align-baseline !px-0 !py-0 bg-transparent cursor-pointer",
                                    onClick: function() {
                                        var ref, ref1, ref2;
                                        return void handleNavLinkClick(rawHref, link === null || link === void 0 ? void 0 : (ref = link.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.ButtonUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.target);
                                    },
                                    children: link === null || link === void 0 ? void 0 : (ref11 = link.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.ButtonText) === null || ref12 === void 0 ? void 0 : ref12.value
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_1__.Button, {
                                    style: navStyle,
                                    classNames: "border-none md:!text-[14px] !text-[10px] !flex !align-baseline  !px-0 !py-0 ",
                                    redirect: (link === null || link === void 0 ? void 0 : (ref13 = link.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.ButtonUrl) === null || ref14 === void 0 ? void 0 : ref14.value) ? (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_2__.CleanRelativeLink)(link === null || link === void 0 ? void 0 : (ref15 = link.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.ButtonUrl) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.href) : "",
                                    target: link === null || link === void 0 ? void 0 : (ref18 = link.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.ButtonUrl) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.value) === null || ref20 === void 0 ? void 0 : ref20.target,
                                    text: link === null || link === void 0 ? void 0 : (ref21 = link.fields) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.ButtonText) === null || ref22 === void 0 ? void 0 : ref22.value,
                                    linktype: link === null || link === void 0 ? void 0 : (ref23 = link.fields) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.ButtonUrl) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.value) === null || ref25 === void 0 ? void 0 : ref25.linktype
                                })
                            }, index);
                        })),
                        !(props === null || props === void 0 ? void 0 : (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.ShowLinksAtEnd) === null || ref14 === void 0 ? void 0 : ref14.value) && (props === null || props === void 0 ? void 0 : (ref15 = props.ScrollTo) === null || ref15 === void 0 ? void 0 : ref15.length) > 0 && (props === null || props === void 0 ? void 0 : (ref16 = props.ScrollTo) === null || ref16 === void 0 ? void 0 : ref16.map(function(link, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                onClick: function() {
                                    return scrollTopFunction(link === null || link === void 0 ? void 0 : link.SectionId);
                                },
                                style: {
                                    color: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.NavigationTextColor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value,
                                    fontFamily: (ref6 = props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.NavigationTextFont) === null || ref5 === void 0 ? void 0 : ref5.fields.Title) === null || ref6 === void 0 ? void 0 : ref6.value
                                },
                                className: "cursor-pointer !border-none md:!text-[14px] !text-[10px] ",
                                children: link === null || link === void 0 ? void 0 : link.ScrollToText
                            }, index);
                        })),
                        (props === null || props === void 0 ? void 0 : (ref17 = props.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.DownloadBtnText) === null || ref18 === void 0 ? void 0 : ref18.value) && (props === null || props === void 0 ? void 0 : (ref19 = props.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.DownloadBtnFile) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.value) === null || ref21 === void 0 ? void 0 : ref21.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "cursor-pointer ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                style: {
                                    fontFamily: props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.NavigationTextFont) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.fields) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.Title) === null || ref25 === void 0 ? void 0 : ref25.value,
                                    color: props === null || props === void 0 ? void 0 : (ref26 = props.fields) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.NavigationTextColor) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.fields) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.Title) === null || ref29 === void 0 ? void 0 : ref29.value
                                },
                                onClick: onDownloadFile,
                                className: "animate-top inline-flex items-center gap-2 border-none md:!text-[14px] !text-[10px] !align-baseline !px-0 !py-0",
                                children: [
                                    (ref30 = props === null || props === void 0 ? void 0 : props.fields.DownloadBtnText) === null || ref30 === void 0 ? void 0 : ref30.value,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_3__.TemplateDownloadIcon, {
                                        color: props === null || props === void 0 ? void 0 : (ref31 = props.fields) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.NavigationTextColor) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.fields) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.Title) === null || ref34 === void 0 ? void 0 : ref34.value,
                                        size: 18
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-span-12 md:col-span-2 w-full flex justify-end items-start",
                    children: function() {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                        var rawCustom = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.CustomBtnUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.href;
                        var customStyle = {
                            color: props === null || props === void 0 ? void 0 : (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.CustomBtnTextColor) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Title) === null || ref6 === void 0 ? void 0 : ref6.value,
                            fontFamily: props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.CustomBtnTextFont) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Title) === null || ref10 === void 0 ? void 0 : ref10.value,
                            background: props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.CustomBtnBoxColor) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Title) === null || ref14 === void 0 ? void 0 : ref14.value
                        };
                        if (rawCustom && (0,src_util_href_download_handling__WEBPACK_IMPORTED_MODULE_5__/* .hrefIsTrackedFileDownload */ .P)(rawCustom)) {
                            var ref23, ref24;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                style: customStyle,
                                className: "border-none md:!text-[14px] !text-[10px] !flex !align-baseline !px-4 !py-2 mt-2 md:mt-0 rounded cursor-pointer",
                                onClick: function() {
                                    var ref, ref1, ref2;
                                    return void handleNavLinkClick(rawCustom, props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.CustomBtnUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.target);
                                },
                                children: props === null || props === void 0 ? void 0 : (ref23 = props.fields) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.CustomBtnText) === null || ref24 === void 0 ? void 0 : ref24.value
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_1__.Button, {
                            style: customStyle,
                            classNames: "border-none md:!text-[14px] !text-[10px] !flex !align-baseline  !px-4 !py-2 mt-2 md:mt-0",
                            redirect: rawCustom ? (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_2__.CleanRelativeLink)(rawCustom) : "",
                            target: props === null || props === void 0 ? void 0 : (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.CustomBtnUrl) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.target,
                            text: props === null || props === void 0 ? void 0 : (ref18 = props.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.CustomBtnText) === null || ref19 === void 0 ? void 0 : ref19.value,
                            linktype: props === null || props === void 0 ? void 0 : (ref20 = props.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.CustomBtnUrl) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.value) === null || ref22 === void 0 ? void 0 : ref22.linktype
                        });
                    }()
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (TemplateNavigation1);


/***/ }),

/***/ 28064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InitiativeThreeColsLgCardsSwiper": function() { return /* binding */ InitiativeThreeColsLgCardsSwiper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74627);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30706);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73165);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62009);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16606);
/* harmony import */ var components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90894);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 

// Import Swiper React components

// Import Swiper styles



// import required modules





var InitiativeThreeColsLgCardsSwiper = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), swiper = ref26[0], setSwiper = ref26[1];
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEnd = ref27[0], setIsEnd = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBeginning = ref28[0], setIsBeginning = ref28[1];
    var handleSwiperUpdate = function(swiper) {
        setSwiper(swiper);
        // check if at end or at beginneg
        swiper.on("slideChange", function() {
            if (swiper.isEnd) {
                setIsEnd(true);
            } else {
                setIsEnd(false);
            }
            if (swiper.isBeginning) {
                setIsBeginning(true);
            } else {
                setIsBeginning(false);
            }
        });
    };
    var componentId = "".concat(props === null || props === void 0 ? void 0 : props.SectionId, "-").concat(props === null || props === void 0 ? void 0 : props.sectionIx).trim().replace(/ /g, "-");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // Optional: attach listener once only
            swiper.on("slideChange", function() {
                setIsBeginning(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: "py-10 flex flex-col gap-8",
        children: [
            ((props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value) || (props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Description) === null || ref3 === void 0 ? void 0 : ref3.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "responsive flex flex-col gap-8",
                children: [
                    (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Title) === null || ref5 === void 0 ? void 0 : ref5.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "animate-top-dga text-3xl font-bold",
                        children: props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Title) === null || ref7 === void 0 ? void 0 : ref7.value
                    }),
                    (props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Description) === null || ref9 === void 0 ? void 0 : ref9.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "animate-top-dga overflow-hidden text-base font-normal",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                            field: props === null || props === void 0 ? void 0 : (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : ref10.Description
                        })
                    })
                ]
            }),
            (props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : ref11.Items) && (props === null || props === void 0 ? void 0 : (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.Items) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(swiper ? "opacity-100" : "opacity-0", " transition-opacity duration-500 ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-[5%] " : "ml-[5%] ", " md:responsive pt-10"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                        onInit: function(ev) {
                            setSwiper(ev);
                            if (ev.isEnd) {
                                setIsEnd(true);
                            } else {
                                setIsEnd(false);
                            }
                            if (ev.isBeginning) {
                                setIsBeginning(true);
                            } else {
                                setIsBeginning(false);
                            }
                        },
                        onSwiper: function(e) {
                            handleSwiperUpdate(e);
                        // check end and beginner
                        },
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 24
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 24
                            }
                        },
                        pagination: {
                            clickable: true,
                            el: "#".concat(componentId)
                        },
                        freeMode: true,
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl,
                            swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5
                        ],
                        a11y: {
                            enabled: true,
                            paginationBulletMessage: "Go to slide {{index}}"
                        },
                        dir: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "rtl" : "ltr",
                        className: "mySwiper !p-[1px]",
                        children: (props === null || props === void 0 ? void 0 : (ref14 = props.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.Items) === null || ref15 === void 0 ? void 0 : ref15.length) > 0 && (props === null || props === void 0 ? void 0 : (ref16 = props.fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.Items) === null || ref17 === void 0 ? void 0 : ref17.map(function(card, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                            var ref18, ref19;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                                className: "w-full !text-start !h-auto overflow-hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: " animate-top-dga w-full border border-neutral-300 rounded-2xl h-full p-4 flex bg-white flex-col gap-5 items-center",
                                    children: [
                                        (card === null || card === void 0 ? void 0 : (ref = card.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Icon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[48px] bg-neutral-100 rounded-full relative w-[48px] mx-auto",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                unoptimized: true,
                                                src: card === null || card === void 0 ? void 0 : (ref3 = card.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Icon) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.src,
                                                alt: ((ref18 = card === null || card === void 0 ? void 0 : (ref6 = card.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Icon) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.alt) !== null && ref18 !== void 0 ? ref18 : "").trim() || ((ref19 = card === null || card === void 0 ? void 0 : (ref9 = card.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Title) === null || ref10 === void 0 ? void 0 : ref10.value) !== null && ref19 !== void 0 ? ref19 : "").trim() || "Initiative icon",
                                                layout: "fill",
                                                objectFit: "contain"
                                            })
                                        }),
                                        (card === null || card === void 0 ? void 0 : (ref11 = card.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Title) === null || ref12 === void 0 ? void 0 : ref12.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg font-bold",
                                            children: card === null || card === void 0 ? void 0 : (ref13 = card.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Title) === null || ref14 === void 0 ? void 0 : ref14.value
                                        }),
                                        (card === null || card === void 0 ? void 0 : (ref15 = card.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Description) === null || ref16 === void 0 ? void 0 : ref16.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                            id: "section-point-" + (props === null || props === void 0 ? void 0 : props.SectionId) + "-" + index,
                                            className: "",
                                            field: card === null || card === void 0 ? void 0 : (ref17 = card.fields) === null || ref17 === void 0 ? void 0 : ref17.Description
                                        })
                                    ]
                                })
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: componentId,
                        className: "md:hidden custom_swiper !mt-8 mx-auto !justify-center"
                    }),
                    (props === null || props === void 0 ? void 0 : (ref18 = props.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.Items) === null || ref19 === void 0 ? void 0 : ref19.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "\n        ".concat(swiper ? "opacity-100" : "opacity-0", "\n        w-fit\n        ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-auto" : "ml-auto", "\n        flex-row gap-4 mt-8\n        ").concat((props === null || props === void 0 ? void 0 : (ref20 = props.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.Items) === null || ref21 === void 0 ? void 0 : ref21.length) > 1 ? "hidden" : "hidden", "\n        ").concat((props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.Items) === null || ref23 === void 0 ? void 0 : ref23.length) > 2 ? "md:flex" : "md:hidden", "\n        ").concat((props === null || props === void 0 ? void 0 : (ref24 = props.fields) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.Items) === null || ref25 === void 0 ? void 0 : ref25.length) > 3 ? "lg:flex" : "lg:hidden", "\n      "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                                direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "right" : "left",
                                onClick: function() {
                                    swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                    handleSwiperUpdate(swiper);
                                },
                                size: "large",
                                disabled: isBeginning,
                                style: "primary"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                                direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "left" : "right",
                                onClick: function() {
                                    swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                    handleSwiperUpdate(swiper);
                                },
                                size: "large",
                                disabled: isEnd,
                                style: "primary"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InitiativeThreeColsMedCardSwiperSection": function() { return /* binding */ InitiativeThreeColsMedCardSwiperSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74627);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30706);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73165);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62009);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16606);
/* harmony import */ var components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90894);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 

// Import Swiper React components

// Import Swiper styles



// import required modules





var InitiativeThreeColsMedCardSwiperSection = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), swiper = ref19[0], setSwiper = ref19[1];
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEnd = ref20[0], setIsEnd = ref20[1];
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBeginning = ref21[0], setIsBeginning = ref21[1];
    var handleSwiperUpdate = function(swiper) {
        setSwiper(swiper);
        // check if at end or at beginneg
        swiper.on("slideChange", function() {
            if (swiper.isEnd) {
                setIsEnd(true);
            } else {
                setIsEnd(false);
            }
            if (swiper.isBeginning) {
                setIsBeginning(true);
            } else {
                setIsBeginning(false);
            }
        });
    };
    var componentId = "".concat(props === null || props === void 0 ? void 0 : props.SectionId, "-").concat(props === null || props === void 0 ? void 0 : props.sectionIx).trim().replace(/ /g, "-");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // Optional: attach listener once only
            swiper.on("slideChange", function() {
                setIsBeginning(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: " py-10",
        children: [
            (props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-3xl responsive font-bold animate-top-dga",
                children: props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value
            }),
            (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : ref4.Items) && (props === null || props === void 0 ? void 0 : (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Items) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:responsive",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(swiper ? "opacity-100" : "opacity-0", " transition-opacity duration-500 ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-[5%] " : "ml-[5%] ", " md:responsive pt-10"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                                onInit: function(ev) {
                                    setSwiper(ev);
                                    if (ev.isEnd) {
                                        setIsEnd(true);
                                    } else {
                                        setIsEnd(false);
                                    }
                                    if (ev.isBeginning) {
                                        setIsBeginning(true);
                                    } else {
                                        setIsBeginning(false);
                                    }
                                },
                                onSwiper: function(e) {
                                    handleSwiperUpdate(e);
                                // check end and beginner
                                },
                                slidesPerView: 1.2,
                                spaceBetween: 16,
                                breakpoints: {
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 24
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 24
                                    }
                                },
                                pagination: {
                                    clickable: true,
                                    el: "#".concat(componentId)
                                },
                                freeMode: true,
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl,
                                    swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5
                                ],
                                a11y: {
                                    enabled: true,
                                    paginationBulletMessage: "Go to slide {{index}}"
                                },
                                dir: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "rtl" : "ltr",
                                className: "mySwiper",
                                children: (props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Items) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && (props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Items) === null || ref10 === void 0 ? void 0 : ref10.map(function(card, index) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                                    var ref18, ref19;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                                        className: "w-full !h-auto overflow-hidden",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: " animate-top-dga w-full rounded-2xl h-full p-4 flex bg-white flex-col gap-5 items-center",
                                            children: [
                                                (card === null || card === void 0 ? void 0 : (ref = card.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Icon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "h-[48px] bg-neutral-100 rounded-full relative w-[48px] mx-auto",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                        unoptimized: true,
                                                        src: card === null || card === void 0 ? void 0 : (ref3 = card.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Icon) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.src,
                                                        alt: ((ref18 = card === null || card === void 0 ? void 0 : (ref6 = card.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Icon) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.alt) !== null && ref18 !== void 0 ? ref18 : "").trim() || ((ref19 = card === null || card === void 0 ? void 0 : (ref9 = card.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Title) === null || ref10 === void 0 ? void 0 : ref10.value) !== null && ref19 !== void 0 ? ref19 : "").trim() || "Initiative icon",
                                                        layout: "fill",
                                                        objectFit: "contain"
                                                    })
                                                }),
                                                (card === null || card === void 0 ? void 0 : (ref11 = card.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Title) === null || ref12 === void 0 ? void 0 : ref12.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-lg font-bold",
                                                    children: card === null || card === void 0 ? void 0 : (ref13 = card.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Title) === null || ref14 === void 0 ? void 0 : ref14.value
                                                }),
                                                (card === null || card === void 0 ? void 0 : (ref15 = card.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Description) === null || ref16 === void 0 ? void 0 : ref16.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                                    id: "section-point-" + (props === null || props === void 0 ? void 0 : props.SectionId) + "-" + index,
                                                    className: "",
                                                    field: card === null || card === void 0 ? void 0 : (ref17 = card.fields) === null || ref17 === void 0 ? void 0 : ref17.Description
                                                })
                                            ]
                                        })
                                    }, index);
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: componentId,
                                className: "md:hidden custom_swiper !mt-8 mx-auto !justify-center"
                            })
                        ]
                    }),
                    (props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Items) === null || ref12 === void 0 ? void 0 : ref12.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "\n        ".concat(swiper ? "opacity-100" : "opacity-0", "\n        w-fit\n        ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "mr-auto" : "ml-auto", "\n        flex-row gap-4 mt-8\n        ").concat((props === null || props === void 0 ? void 0 : (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Items) === null || ref14 === void 0 ? void 0 : ref14.length) > 1 ? "hidden" : "hidden", "\n        ").concat((props === null || props === void 0 ? void 0 : (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Items) === null || ref16 === void 0 ? void 0 : ref16.length) > 2 ? "md:flex" : "md:hidden", "\n        ").concat((props === null || props === void 0 ? void 0 : (ref17 = props.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.Items) === null || ref18 === void 0 ? void 0 : ref18.length) > 3 ? "lg:flex" : "lg:hidden", "\n      "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                                direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "right" : "left",
                                onClick: function() {
                                    swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                    handleSwiperUpdate(swiper);
                                },
                                size: "large",
                                disabled: isBeginning,
                                style: "primary"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_9__.DGACarouselArrow, {
                                direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_8__["default"])() ? "left" : "right",
                                onClick: function() {
                                    swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                    handleSwiperUpdate(swiper);
                                },
                                size: "large",
                                disabled: isEnd,
                                style: "primary"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 53821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16606);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56440);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62009);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable prefer-const */ 



// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/dist/ScrollTrigger";




function TimelineSection1(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#1B8354"), currentStepColor = ref8[0];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#1F2A37"), currentStepTitleColor = ref9[0];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#D2D6DB"), otherStepsColor = ref10[0];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#6C737F"), otherStepsTitleColor = ref11[0];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), Steps = ref12[0], setSteps = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentStep = ref13[0], setCurrentStep = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), hoveredStep = ref14[0], setHoveredStep = ref14[1];
    var scrollContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), canScroll = ref15[0], setCanScroll = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), atStart = ref16[0], setAtStart = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), atEnd = ref17[0], setAtEnd = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLargeScreen = ref18[0], setIsLargeScreen = ref18[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var largeScreenMinLimit = 1024;
        if (window.innerWidth >= largeScreenMinLimit) setIsLargeScreen(true);
        else setIsLargeScreen(false);
    }, [
        props
    ]);
    // Function to check if scrolling is needed
    var checkScroll = function() {
        if (scrollContainerRef.current) {
            var _current = scrollContainerRef.current, scrollWidth = _current.scrollWidth, clientWidth = _current.clientWidth, scrollLeft = _current.scrollLeft;
            setCanScroll(scrollWidth >= clientWidth);
            if ((props === null || props === void 0 ? void 0 : props.locale) == "en") {
                setAtStart(scrollLeft === 0);
                setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // -1 for precision
            } else {
                setAtStart(scrollLeft === 0);
                setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // -1 for precision
            }
        }
    };
    // Function to scroll left or right
    var scroll = function(direction) {
        if (scrollContainerRef.current) {
            var scrollAmount = 200;
            scrollContainerRef.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth"
            });
        }
    };
    // Check scrollability on initial render
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTimeout(function() {
            checkScroll();
        }, 1000);
    }, []);
    // Check scrollability on mount and resize
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        checkScroll();
        window.addEventListener("resize", checkScroll);
        return function() {
            return window.removeEventListener("resize", checkScroll);
        };
    }, []);
    // Update scroll position state when user scrolls
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current) {
            var ref;
            scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : (ref = scrollContainerRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", checkScroll);
            return function() {
                var ref;
                return scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : (ref = scrollContainerRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", checkScroll);
            };
        }
        return scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;
    }, []);
    // Generic date formatter that handles multiple languages using moment
    var formatDate = function(dateString, locale) {
        if (!dateString) return "";
        var date = moment__WEBPACK_IMPORTED_MODULE_2___default()(dateString);
        // Check if date is valid
        if (!date.isValid()) return "";
        // Set locale based on language
        var momentLocale = locale || "en";
        if (locale === "ar") {
            momentLocale = "ar-ly"; // Arabic locale used in the codebase
        }
        // Format based on language
        // English: "DD MMM" (no year), Arabic/Chinese/Korean: "D MMM YYYY" (with year)
        var format = "D MMM YYYY";
        return date.locale(momentLocale).format(format);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        if (props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.TimelineSteps) === null || ref1 === void 0 ? void 0 : ref1.length) {
            var ref2, ref3, ref4, ref5;
            var temp;
            var length = props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.TimelineSteps) === null || ref3 === void 0 ? void 0 : ref3.length; // Desired length of the array
            var emptyObject = {
                displayName: "",
                fields: {
                    Title: {
                        value: ""
                    },
                    Description: {
                        value: ""
                    },
                    StartDate: {
                        value: ""
                    },
                    EndDate: {
                        value: ""
                    }
                }
            }; // Object with empty values
            temp = Array.from({
                length: length
            }, function() {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, emptyObject);
            });
            props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.TimelineSteps) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                temp[index] = {
                    displayName: item === null || item === void 0 ? void 0 : item.displayName,
                    fields: {
                        Title: {
                            value: item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value
                        },
                        Description: {
                            value: item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Description) === null || ref3 === void 0 ? void 0 : ref3.value
                        },
                        StartDate: {
                            value: item === null || item === void 0 ? void 0 : (ref4 = item.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.StartDate) === null || ref5 === void 0 ? void 0 : ref5.value
                        },
                        EndDate: {
                            value: item === null || item === void 0 ? void 0 : (ref6 = item.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.EndDate) === null || ref7 === void 0 ? void 0 : ref7.value
                        }
                    }
                };
            });
            temp.map(function(item, index) {
                item.fields.EndDate.value === "0001-01-01T00:00:00Z" ? temp[index].fields.EndDate.value = "" : null;
                item.fields.StartDate.value === "0001-01-01T00:00:00Z" ? temp[index].fields.StartDate.value = "" : null;
            });
            Steps = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(temp);
            setSteps((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Steps));
            var found = false;
            Steps.map(function(step, index) {
                var ref, ref1, ref2, ref3;
                var stepStartDate = new Date(step === null || step === void 0 ? void 0 : (ref = step.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.StartDate) === null || ref1 === void 0 ? void 0 : ref1.value);
                var stepEndDate = new Date(step === null || step === void 0 ? void 0 : (ref2 = step.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.EndDate) === null || ref3 === void 0 ? void 0 : ref3.value);
                if ((stepStartDate.getTime() > new Date(Date.now() - 24 * 60 * 60 * 1000).getTime() || stepEndDate.getTime() > new Date(Date.now() - 24 * 60 * 60 * 1000).getTime()) && !found) {
                    setCurrentStep(index);
                    setHoveredStep(index);
                    found = true;
                }
            });
        }
    }, []);
    // useEffect(() => {
    //   if (props?.showAnimation) {
    //     gsap.set(".animate-top", {
    //       opacity: 0,
    //       y: 100,
    //     });
    //     ScrollTrigger.batch(".animate-top", {
    //       onEnter: (batch) =>
    //         gsap.to(batch, {
    //           opacity: 1,
    //           y: 0,
    //           stagger: { each: 0.3 },
    //           overwrite: true,
    //           scrollTrigger: {
    //             trigger: batch,
    //             start: "top 85%",
    //             end: "bottom 20%",
    //             once: true,
    //             invalidateOnRefresh: true,
    //           },
    //         }),
    //       onEnterBack: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
    //     });
    //   }
    // }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: "w-full relative py-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "animate-top-dga responsive relative z-10 mb-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "animate-top-dga text-[#161616] font-bold  text-[30px]  ",
                                children: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                className: " animate-top-dga lg:text-[18px] !font-normal md:text-[16px] text-[12px] text-[#1F2A37]",
                                field: props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : ref2.Description
                            })
                        ]
                    })
                }),
                !isLargeScreen && (Steps === null || Steps === void 0 ? void 0 : Steps.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "animate-top-dga relative flex flex-col gap-5 my-6 responsive",
                    children: (Steps === null || Steps === void 0 ? void 0 : Steps.length) && (Steps === null || Steps === void 0 ? void 0 : Steps.map(function(item, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            onClick: function() {
                                index === hoveredStep ? setHoveredStep(-1) : setHoveredStep(index);
                            },
                            className: "flex relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-center w-[40px] h-[40px] rounded-full relative z-10   border-[2px] font-bold",
                                    style: {
                                        color: index == currentStep ? currentStepColor : otherStepsColor,
                                        borderColor: index == currentStep ? currentStepColor : otherStepsColor,
                                        background: "white"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            color: index == currentStep ? currentStepColor : otherStepsColor
                                        },
                                        children: index + 1
                                    })
                                }),
                                index !== (Steps === null || Steps === void 0 ? void 0 : Steps.length) - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute h-full w-[1px]  bg-[#0F2837] ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "right-[19px]" : "left-[19px]", " top-8 z-0"),
                                    style: {
                                        background: index == currentStep ? currentStepColor : otherStepsColor
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col  ".concat((props === null || props === void 0 ? void 0 : props.locale) == "en" ? "ml-10" : "mr-10", " w-[72%] md:w-[90%]"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mb-2 text-[16px] max-w-[300px] whitespace-normal transform duration-200 transition-all ease-in-out",
                                            style: {
                                                color: index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                                                fontWeight: index === hoveredStep ? "500" : "normal"
                                            },
                                            children: item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "date text-[14px] font-thin transform duration-200 transition-all ease-in-out !ltr",
                                            style: {
                                                color: index == currentStep ? currentStepTitleColor : otherStepsTitleColor
                                            },
                                            children: ((item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.StartDate) === null || ref3 === void 0 ? void 0 : ref3.value) ? formatDate(item === null || item === void 0 ? void 0 : (ref4 = item.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.StartDate) === null || ref5 === void 0 ? void 0 : ref5.value, (props === null || props === void 0 ? void 0 : props.locale) || "en") : "  ") + ((item === null || item === void 0 ? void 0 : (ref6 = item.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.EndDate) === null || ref7 === void 0 ? void 0 : ref7.value) ? " - " + formatDate(item === null || item === void 0 ? void 0 : (ref8 = item.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.EndDate) === null || ref9 === void 0 ? void 0 : ref9.value, (props === null || props === void 0 ? void 0 : props.locale) || "en") : "  ")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "my-4 !text-[14px] lg:max-w-[100vw] whitespace-normal transform duration-200 transition-all ease-in-out ",
                                            style: {
                                                color: hoveredStep == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                                                wordWrap: "break-word",
                                                overflowWrap: "break-word",
                                                hyphens: "auto",
                                                height: index === hoveredStep ? "fit-content" : "0px",
                                                opacity: index === hoveredStep ? 1 : 0,
                                                transform: index === hoveredStep ? "translateY(0)" : "translateY(-15px)",
                                                transition: "max-height 0.5s ease-in, opacity 0.4s ease-in, color 0.4s ease-in,height 0.4s ease-in,transform 0.4s ease-in"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                                field: item === null || item === void 0 ? void 0 : (ref10 = item.fields) === null || ref10 === void 0 ? void 0 : ref10.Description
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }))
                }) : null,
                isLargeScreen && (props === null || props === void 0 ? void 0 : (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.TimelineSteps) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "animate-top-dga responsive overflow-visible scrollbar-hide ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: scrollContainerRef,
                            className: "relative flex flex-row overflow-x-auto scrollbar-hide ",
                            style: {
                                scrollBehavior: "smooth",
                                whiteSpace: "nowrap"
                            },
                            children: (Steps === null || Steps === void 0 ? void 0 : Steps.length) && (Steps === null || Steps === void 0 ? void 0 : Steps.map(function(item, index) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    onMouseEnter: function() {
                                        return setHoveredStep(index);
                                    },
                                    onMouseLeave: function() {
                                        setHoveredStep(currentStep);
                                    },
                                    className: "flex relative !flex-1 !cursor-pointer min-w-[235px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex items-center justify-center w-[40px] h-[40px] rounded-full relative z-10 border-[2px] font-bold",
                                            style: {
                                                color: index == currentStep ? currentStepColor : otherStepsColor,
                                                borderColor: index == currentStep ? currentStepColor : otherStepsColor,
                                                background: "white"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                style: {
                                                    color: index == currentStep ? currentStepColor : otherStepsColor
                                                },
                                                children: index + 1
                                            })
                                        }),
                                        index !== (Steps === null || Steps === void 0 ? void 0 : Steps.length) - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute w-full h-[1px]  ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "right-[19px]" : "left-[19px]", " top-5 z-0"),
                                            style: {
                                                background: index == currentStep ? currentStepColor : otherStepsColor
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col  ".concat((props === null || props === void 0 ? void 0 : props.locale) == "en" ? "-ml-7" : "-mr-7", " mt-16 "),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mb-2 text-[16px] max-w-[217px] whitespace-normal transform duration-200 transition-all ease-in-out",
                                                    style: {
                                                        color: index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                                                        transform: index === hoveredStep ? "scale(1.04)" : "none",
                                                        fontWeight: index === hoveredStep ? "500" : "normal"
                                                    },
                                                    children: item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "date text-[14px] font-thin transform duration-200 transition-all ease-in-out !ltr",
                                                    style: {
                                                        color: index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                                                        transform: index === hoveredStep ? "scale(1.04)" : "none"
                                                    },
                                                    children: ((item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.StartDate) === null || ref3 === void 0 ? void 0 : ref3.value) ? formatDate(item === null || item === void 0 ? void 0 : (ref4 = item.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.StartDate) === null || ref5 === void 0 ? void 0 : ref5.value, (props === null || props === void 0 ? void 0 : props.locale) || "en") : "    ") + ((item === null || item === void 0 ? void 0 : (ref6 = item.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.EndDate) === null || ref7 === void 0 ? void 0 : ref7.value) ? " - " + formatDate(item === null || item === void 0 ? void 0 : (ref8 = item.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.EndDate) === null || ref9 === void 0 ? void 0 : ref9.value, (props === null || props === void 0 ? void 0 : props.locale) || "en") : "  ")
                                                })
                                            ]
                                        })
                                    ]
                                }, index);
                            }))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "my-10  border-red-300 lg:max-w-[80vw] whitespace-normal ",
                            style: {
                                color: hoveredStep == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                hyphens: "auto"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                field: (ref6 = props === null || props === void 0 ? void 0 : (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : ref5.TimelineSteps[hoveredStep]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.Description
                            })
                        }),
                        atEnd && atStart ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            dir: "ltr",
                            className: " w-fit ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "mr-auto" : "ml-auto", " flex flex-row gap-4 border-red-500"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: " w-fit",
                                    onClick: function() {
                                        return scroll("left");
                                    },
                                    children: [
                                        atStart,
                                        canScroll && ((props === null || props === void 0 ? void 0 : props.locale) === "en" && !atStart || !atEnd && (props === null || props === void 0 ? void 0 : props.locale) == "ar") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 48 48",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": true,
                                            focusable: "false",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                    width: "48",
                                                    height: "48",
                                                    rx: "24",
                                                    fill: "#1B8354"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M26.9998 32.6695C26.8098 32.6695 26.6198 32.5995 26.4698 32.4495L19.9498 25.9295C18.8898 24.8695 18.8898 23.1295 19.9498 22.0695L26.4698 15.5495C26.7598 15.2595 27.2398 15.2595 27.5298 15.5495C27.8198 15.8395 27.8198 16.3195 27.5298 16.6095L21.0098 23.1295C20.5298 23.6095 20.5298 24.3895 21.0098 24.8695L27.5298 31.3895C27.8198 31.6795 27.8198 32.1595 27.5298 32.4495C27.3798 32.5895 27.1898 32.6695 26.9998 32.6695Z",
                                                    fill: "#ffffff"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 48 48",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": true,
                                            focusable: "false",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                    width: "48",
                                                    height: "48",
                                                    rx: "24",
                                                    fill: "#F9FAFB"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M26.9998 32.6695C26.8098 32.6695 26.6198 32.5995 26.4698 32.4495L19.9498 25.9295C18.8898 24.8695 18.8898 23.1295 19.9498 22.0695L26.4698 15.5495C26.7598 15.2595 27.2398 15.2595 27.5298 15.5495C27.8198 15.8395 27.8198 16.3195 27.5298 16.6095L21.0098 23.1295C20.5298 23.6095 20.5298 24.3895 21.0098 24.8695L27.5298 31.3895C27.8198 31.6795 27.8198 32.1595 27.5298 32.4495C27.3798 32.5895 27.1898 32.6695 26.9998 32.6695Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: " w-fit",
                                    onClick: function() {
                                        return scroll("right");
                                    },
                                    children: [
                                        atEnd,
                                        canScroll && ((props === null || props === void 0 ? void 0 : props.locale) === "en" && !atEnd || (props === null || props === void 0 ? void 0 : props.locale) == "ar" && !atStart) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 48 48",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": true,
                                            focusable: "false",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                    width: "48",
                                                    height: "48",
                                                    rx: "24",
                                                    fill: "#1B8354"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M20.9101 32.6695C20.7201 32.6695 20.5301 32.5995 20.3801 32.4495C20.0901 32.1595 20.0901 31.6795 20.3801 31.3895L26.9001 24.8695C27.3801 24.3895 27.3801 23.6095 26.9001 23.1295L20.3801 16.6095C20.0901 16.3195 20.0901 15.8395 20.3801 15.5495C20.6701 15.2595 21.1501 15.2595 21.4401 15.5495L27.9601 22.0695C28.4701 22.5795 28.7601 23.2695 28.7601 23.9995C28.7601 24.7295 28.4801 25.4195 27.9601 25.9295L21.4401 32.4495C21.2901 32.5895 21.1001 32.6695 20.9101 32.6695Z",
                                                    fill: "white"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 48 48",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": true,
                                            focusable: "false",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                    width: "48",
                                                    height: "48",
                                                    rx: "24",
                                                    fill: "#F9FAFB"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M20.9101 32.6695C20.7201 32.6695 20.5301 32.5995 20.3801 32.4495C20.0901 32.1595 20.0901 31.6795 20.3801 31.3895L26.9001 24.8695C27.3801 24.3895 27.3801 23.6095 26.9001 23.1295L20.3801 16.6095C20.0901 16.3195 20.0901 15.8395 20.3801 15.5495C20.6701 15.2595 21.1501 15.2595 21.4401 15.5495L27.9601 22.0695C28.4701 22.5795 28.7601 23.2695 28.7601 23.9995C28.7601 24.7295 28.4801 25.4195 27.9601 25.9295L21.4401 32.4495C21.2901 32.5895 21.1001 32.6695 20.9101 32.6695Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (TimelineSection1);


/***/ }),

/***/ 6878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ 98811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_dga_tabs_tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(848);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56440);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 






var EMPTY_DATE = "0001-01-01T00:00:00Z";
var isValidDate = function(value) {
    return Boolean(value) && value !== EMPTY_DATE && moment__WEBPACK_IMPORTED_MODULE_3___default().utc(value).isValid();
};
var formatSitecoreTime = function(value, locale) {
    var momentLocale = locale === "ar" ? "ar-ly" : locale || "en";
    return moment__WEBPACK_IMPORTED_MODULE_3___default().utc(value).locale(momentLocale).format("h:mm A");
};
var formatTimeRange = function(startTime, endTime, locale) {
    var start = isValidDate(startTime) ? formatSitecoreTime(startTime, locale) : "";
    var end = isValidDate(endTime) ? formatSitecoreTime(endTime, locale) : "";
    if (start && end) return "".concat(start, "-").concat(end);
    return start || end;
};
var hasSpeakersInRows = function(rows) {
    return rows.some(function(row) {
        var ref, ref1, ref2;
        return Boolean(row === null || row === void 0 ? void 0 : (ref = row.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Speakers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.trim());
    });
};
var getTabLabel = function(tab) {
    return tab.fields.TabTitle.value || tab.displayName || tab.name || "";
};
var TimelineWithTabsAndTable = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14;
    var tabs = (ref14 = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : ref.Tabs) !== null && ref14 !== void 0 ? ref14 : [];
    var tabOptions = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return tabs.map(function(tab) {
            return {
                label: getTabLabel(tab),
                value: tab.id
            };
        }).filter(function(tab) {
            return tab.label;
        });
    }, [
        tabs
    ]);
    var ref15;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)((ref15 = (ref1 = tabOptions[0]) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref15 !== void 0 ? ref15 : ""), selectedTabId = ref16[0], setSelectedTabId = ref16[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (tabOptions.length) {
            setSelectedTabId(tabOptions[0].value);
        }
    }, [
        tabOptions
    ]);
    if (!(props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value) && tabs.length === 0) {
        return null;
    }
    var ref17;
    var selectedTab = (ref17 = tabs.find(function(tab) {
        return tab.id === selectedTabId;
    })) !== null && ref17 !== void 0 ? ref17 : tabs[0];
    var ref18;
    var rows = (ref18 = selectedTab === null || selectedTab === void 0 ? void 0 : (ref4 = selectedTab.fields) === null || ref4 === void 0 ? void 0 : ref4.TabTableRows) !== null && ref18 !== void 0 ? ref18 : [];
    var showSpeakersColumn = hasSpeakersInRows(rows);
    var cmsSectionBg = props === null || props === void 0 ? void 0 : (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.SectionBackgroundColor) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.trim();
    var headerCellClass = "p-4 text-xs font-medium text-neutral-700 text-start";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: "py-10 ".concat((props === null || props === void 0 ? void 0 : props.locale) === "ar" ? "rtl" : ""),
        style: cmsSectionBg ? {
            backgroundColor: cmsSectionBg
        } : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive flex flex-col gap-8",
            children: [
                (props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Title) === null || ref9 === void 0 ? void 0 : ref9.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-[30px] font-bold text-primary-1000",
                    children: props.fields.Title.value
                }),
                tabs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        tabOptions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_tabs_tabs__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            tabs: tabOptions,
                            selectedTab: selectedTabId,
                            onTabChange: setSelectedTabId
                        }),
                        rows.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "overflow-x-auto bg-transparent border-t border-b border-neutral-300",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                dir: props.locale === "ar" ? "rtl" : "ltr",
                                className: "w-full border-collapse text-start bg-transparent",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            className: "bg-neutral-100",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    className: headerCellClass,
                                                    children: (ref10 = props.fields.TitleHeaderLabel) === null || ref10 === void 0 ? void 0 : ref10.value
                                                }),
                                                showSpeakersColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    className: headerCellClass,
                                                    children: (ref11 = props.fields.SpeakersHeaderLabel) === null || ref11 === void 0 ? void 0 : ref11.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    className: headerCellClass,
                                                    children: (ref12 = props.fields.DescriptionHeaderLabel) === null || ref12 === void 0 ? void 0 : ref12.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    className: headerCellClass,
                                                    children: (ref13 = props.fields.TimeHeaderLabel) === null || ref13 === void 0 ? void 0 : ref13.value
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                        children: rows.map(function(row) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimelineTableRowItem, {
                                                row: row,
                                                locale: props.locale,
                                                showSpeakersColumn: showSpeakersColumn,
                                                speakersIcon: props.fields.SpeakersCellIcon,
                                                timeIcon: props.fields.TimeCellIcon
                                            }, row.id);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var TimelineTableRowItem = function(param) {
    var row = param.row, locale = param.locale, showSpeakersColumn = param.showSpeakersColumn, speakersIcon = param.speakersIcon, timeIcon = param.timeIcon;
    var ref, ref1, ref2;
    var _fields = row.fields, Title = _fields.Title, Speakers = _fields.Speakers, Description = _fields.Description, StartTime = _fields.StartTime, EndTime = _fields.EndTime;
    var timeRange = formatTimeRange(StartTime === null || StartTime === void 0 ? void 0 : StartTime.value, EndTime === null || EndTime === void 0 ? void 0 : EndTime.value, locale);
    var description = (Description === null || Description === void 0 ? void 0 : (ref = Description.value) === null || ref === void 0 ? void 0 : ref.trim()) || "-";
    var cellClass = "px-4 py-5 text-base text-primary-1000 align-top";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
        className: "border-t border-neutral-300 bg-transparent",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                className: cellClass,
                children: Title === null || Title === void 0 ? void 0 : Title.value
            }),
            showSpeakersColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                className: cellClass,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "inline-flex items-center gap-2",
                    children: [
                        (speakersIcon === null || speakersIcon === void 0 ? void 0 : (ref1 = speakersIcon.value) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(speakersIcon.value.src),
                            alt: speakersIcon.value.alt || "",
                            width: 24,
                            height: 24,
                            className: "shrink-0 size-6 rounded-full"
                        }),
                        Speakers === null || Speakers === void 0 ? void 0 : Speakers.value
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                className: cellClass,
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                className: "".concat(cellClass, " whitespace-nowrap"),
                children: timeRange ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "inline-flex items-center gap-1",
                    children: [
                        (timeIcon === null || timeIcon === void 0 ? void 0 : (ref2 = timeIcon.value) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(timeIcon.value.src),
                            alt: timeIcon.value.alt || "",
                            width: 14,
                            height: 14,
                            className: "shrink-0 size-[14px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "!ltr font-medium text-tag-text",
                            children: timeRange
                        })
                    ]
                }) : "-"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TimelineWithTabsAndTable);


/***/ }),

/***/ 5800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16606);
/* harmony import */ var components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17163);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87664);
/* harmony import */ var _TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34852);
/* harmony import */ var src_hooks_useTrackedHrefDownload__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73775);







function TitleDescriptionBtns(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    var cta = (0,src_hooks_useTrackedHrefDownload__WEBPACK_IMPORTED_MODULE_5__/* .useTrackedHrefDownload */ .o)(props.locale, "mocHome");
    var firstButtonWithLinkValue = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Buttons) === null || ref1 === void 0 ? void 0 : ref1.find(function(button) {
        var ref, ref1, ref2;
        return button === null || button === void 0 ? void 0 : (ref = button.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.BtnUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.href;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            ((props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value) || (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Description) === null || ref5 === void 0 ? void 0 : ref5.value) || (props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : ref6.Buttons.length) > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: props === null || props === void 0 ? void 0 : props.SectionId,
                className: !(props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.isLightBgColor) === null || ref8 === void 0 ? void 0 : ref8.value) && !(props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.isDarkBgColor) === null || ref10 === void 0 ? void 0 : ref10.value) ? "bg-transparent" : (props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.isLightBgColor) === null || ref12 === void 0 ? void 0 : ref12.value) ? "bg-neutral-100" : (props === null || props === void 0 ? void 0 : (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.isDarkBgColor) === null || ref14 === void 0 ? void 0 : ref14.value) ? "bg-neutral-300" : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "responsive flex flex-col items-start gap-6 md:gap-8 w-full py-10",
                    children: [
                        (props === null || props === void 0 ? void 0 : (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Title) === null || ref16 === void 0 ? void 0 : ref16.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            id: "title-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                            className: "animate-top-dga text-neutral-800 text-2xl md:text-3xl font-bold",
                            children: props === null || props === void 0 ? void 0 : (ref17 = props.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.Title) === null || ref18 === void 0 ? void 0 : ref18.value
                        }),
                        (props === null || props === void 0 ? void 0 : (ref19 = props.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.Description) === null || ref20 === void 0 ? void 0 : ref20.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .RichText */ .H, {
                            id: "desc-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                            field: props === null || props === void 0 ? void 0 : (ref21 = props.fields) === null || ref21 === void 0 ? void 0 : ref21.Description,
                            className: "animate-top-dga overflow-hidden text-neutral-800 text-start text-base md:text-lg font-normal"
                        }),
                        (props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : ref22.Buttons.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "overflow-hidden animate-top-dga flex flex-wrap gap-2 md:gap-4 w-full items-center justify-start",
                            children: props === null || props === void 0 ? void 0 : (ref23 = props.fields) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.Buttons) === null || ref24 === void 0 ? void 0 : ref24.map(function(btn, index) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
                                return cta.linkButtonIsTrackedDownload(btn) ? (btn === null || btn === void 0 ? void 0 : (ref = btn.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.BtnText) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return void cta.handleLinkButton(btn);
                                    },
                                    className: "inline-flex items-center gap-2 ".concat((btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "dga-primary-button" : "dga-secondary-button"),
                                    children: [
                                        btn === null || btn === void 0 ? void 0 : (ref2 = btn.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.BtnText) === null || ref3 === void 0 ? void 0 : ref3.value,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_4__.TemplateDownloadIcon, {
                                            variant: (btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "white" : "grey",
                                            size: 20
                                        })
                                    ]
                                }, (btn === null || btn === void 0 ? void 0 : btn.id) || index) : (btn === null || btn === void 0 ? void 0 : (ref4 = btn.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.BtnText) === null || ref5 === void 0 ? void 0 : ref5.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_2__.Button, {
                                    text: btn === null || btn === void 0 ? void 0 : (ref6 = btn.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.BtnText) === null || ref7 === void 0 ? void 0 : ref7.value,
                                    redirect: btn === null || btn === void 0 ? void 0 : (ref8 = btn.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.BtnUrl) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.value) === null || ref10 === void 0 ? void 0 : ref10.href,
                                    target: btn === null || btn === void 0 ? void 0 : (ref11 = btn.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.BtnUrl) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.value) === null || ref13 === void 0 ? void 0 : ref13.target,
                                    linktype: btn === null || btn === void 0 ? void 0 : (ref14 = btn.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.BtnUrl) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.value) === null || ref16 === void 0 ? void 0 : ref16.linktype,
                                    classNames: "".concat((btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "dga-primary-button" : "dga-secondary-button", " !border-none !text-base !font-medium !py-2 !px-4")
                                }, (btn === null || btn === void 0 ? void 0 : btn.id) || index);
                            })
                        })
                    ]
                })
            }),
            (props === null || props === void 0 ? void 0 : (ref25 = props.fields) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.Pattern) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.value) === null || ref27 === void 0 ? void 0 : ref27.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: (props === null || props === void 0 ? void 0 : props.SectionId) + "-pattern",
                className: "relative w-full max-h-[200px] overflow-hidden",
                style: {
                    height: +(props === null || props === void 0 ? void 0 : (ref28 = props.fields) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.Pattern) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.value) === null || ref30 === void 0 ? void 0 : ref30.height) + "px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__.extractRelativePath)(props === null || props === void 0 ? void 0 : (ref31 = props.fields) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.Pattern) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.value) === null || ref33 === void 0 ? void 0 : ref33.src),
                    alt: (props === null || props === void 0 ? void 0 : (ref34 = props.fields) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.Pattern) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.value) === null || ref36 === void 0 ? void 0 : ref36.alt) || (props === null || props === void 0 ? void 0 : (ref37 = props.fields) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.Title) === null || ref38 === void 0 ? void 0 : ref38.value) || "Event pattern background",
                    layout: "fill",
                    objectFit: "cover",
                    className: "animate-top-dga"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (TitleDescriptionBtns);


/***/ }),

/***/ 17908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16606);
/* harmony import */ var components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17163);
/* harmony import */ var components_Shared_FileDetailComponent_FileDetailComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86020);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87664);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34852);
/* harmony import */ var src_util_CommonApis__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22906);











function normalizeButtons(buttons) {
    if (!buttons) return [];
    if (Array.isArray(buttons)) return buttons.filter(Boolean);
    return [];
}
function normalizeMediaPath(url) {
    var trimmed = url.trim();
    if (!trimmed) return "";
    var dashIndex = trimmed.indexOf("/-/");
    if (dashIndex !== -1) {
        return trimmed.substring(dashIndex);
    }
    return (0,components_Shared_FileDetailComponent_FileDetailComponent__WEBPACK_IMPORTED_MODULE_5__.getPdfPath)(trimmed);
}
function prefixSitecoreHost(path) {
    if (!path.startsWith("/")) return path;
    var host = ("https://c-admin.takamulstg.com" || 0).replace(/\/$/, "");
    return host ? "".concat(host).concat(path) : path;
}
/** Browser-reachable download URL (CD host), not localhost-relative /-/media. */ function resolveDownloadHref(rawSrc) {
    var trimmed = rawSrc.trim();
    if (!trimmed) return "";
    if (/^https?:\/\//i.test(trimmed)) {
        var extracted = (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.extractRelativePath)(trimmed);
        if (extracted && /^https?:\/\//i.test(extracted)) {
            return extracted;
        }
        if (extracted === null || extracted === void 0 ? void 0 : extracted.startsWith("/")) {
            return prefixSitecoreHost(extracted);
        }
        return extracted || trimmed;
    }
    return prefixSitecoreHost(normalizeMediaPath(trimmed));
}
function resolveButtonRawFileSrc(btn) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var fileSrc = btn === null || btn === void 0 ? void 0 : (ref = btn.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.File) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.trim();
    if (fileSrc) return fileSrc;
    var btnUrl = btn === null || btn === void 0 ? void 0 : (ref4 = btn.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.BtnUrl) === null || ref5 === void 0 ? void 0 : ref5.value;
    if (!btnUrl) return "";
    return ((btn === null || btn === void 0 ? void 0 : (ref6 = btn.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.isFile) === null || ref7 === void 0 ? void 0 : ref7.value) ? btnUrl.url || btnUrl.href : btnUrl.href || btnUrl.url).trim();
}
function resolveButtonFileName(btn, fileSrc) {
    var ref, ref1, ref2;
    var fileValue = btn === null || btn === void 0 ? void 0 : (ref = btn.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.File) === null || ref1 === void 0 ? void 0 : ref1.value;
    var fileFieldName = ((fileValue === null || fileValue === void 0 ? void 0 : fileValue.name) || (fileValue === null || fileValue === void 0 ? void 0 : fileValue.title) || "").trim();
    var fileExtension = ((fileValue === null || fileValue === void 0 ? void 0 : fileValue.extension) || "").trim();
    if (fileFieldName) {
        if (fileExtension && !fileFieldName.toLowerCase().endsWith(".".concat(fileExtension.toLowerCase()))) {
            return "".concat(fileFieldName, ".").concat(fileExtension);
        }
        return fileFieldName;
    }
    return ((ref2 = fileSrc.split("/").pop()) === null || ref2 === void 0 ? void 0 : ref2.split("?")[0]) || "";
}
function isRenderableButton(btn) {
    var ref, ref1, ref2;
    return Boolean(btn === null || btn === void 0 ? void 0 : (ref = btn.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.BtnText) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.trim());
}
function TitleDescriptionImage1(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var buttons = normalizeButtons(props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : ref.Buttons);
    var renderableButtons = buttons.filter(isRenderableButton);
    var handleFileDownloadClick = function(event, fileName) {
        event.stopPropagation();
        void (0,src_util_CommonApis__WEBPACK_IMPORTED_MODULE_8__/* .submitFileDownload */ .Y)({
            Language: props.locale || router.locale || "en",
            FileName: fileName,
            PageName: router.asPath,
            Commision: "Moc"
        }).catch(function() {
        /* allow native anchor download */ });
    };
    if (!(props === null || props === void 0 ? void 0 : (ref1 = props.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Title) === null || ref2 === void 0 ? void 0 : ref2.value) && !(props === null || props === void 0 ? void 0 : (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Image) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.src) && !(props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Description) === null || ref7 === void 0 ? void 0 : ref7.value) && renderableButtons.length === 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var firstButtonWithLinkValue = renderableButtons[0];
    var ref52, ref53, ref54, ref55;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        id: props === null || props === void 0 ? void 0 : props.SectionId,
        className: "py-10 " + (!(props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.isLightBgColor) === null || ref9 === void 0 ? void 0 : ref9.value) && !(props === null || props === void 0 ? void 0 : (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.isDarkBgColor) === null || ref11 === void 0 ? void 0 : ref11.value) ? "bg-transparent" : (props === null || props === void 0 ? void 0 : (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.isLightBgColor) === null || ref13 === void 0 ? void 0 : ref13.value) ? "bg-neutral-100" : (props === null || props === void 0 ? void 0 : (ref14 = props.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.isDarkBgColor) === null || ref15 === void 0 ? void 0 : ref15.value) ? "bg-neutral-300" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive flex flex-col md:flex-row items-stretch gap-6 w-full",
            children: [
                ((props === null || props === void 0 ? void 0 : (ref16 = props.fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.Title) === null || ref17 === void 0 ? void 0 : ref17.value) || (props === null || props === void 0 ? void 0 : (ref18 = props.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.Image) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.value) === null || ref20 === void 0 ? void 0 : ref20.src) || (props === null || props === void 0 ? void 0 : (ref21 = props.fields) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.Description) === null || ref22 === void 0 ? void 0 : ref22.value) || renderableButtons.length > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1 flex flex-col items-start gap-6 md:gap-8",
                    children: [
                        (props === null || props === void 0 ? void 0 : (ref23 = props.fields) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.Title) === null || ref24 === void 0 ? void 0 : ref24.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            id: "section-title-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                            className: " animate-top-dga text-neutral-800 text-start text-3xl font-bold",
                            children: props === null || props === void 0 ? void 0 : (ref25 = props.fields) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.Title) === null || ref26 === void 0 ? void 0 : ref26.value
                        }),
                        (props === null || props === void 0 ? void 0 : (ref27 = props.fields) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.Image) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.value) === null || ref29 === void 0 ? void 0 : ref29.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_responsive__WEBPACK_IMPORTED_MODULE_9___default()), {
                            maxWidth: 767.98,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative min-h-[160px] h-full w-full p-4 pb-0 md:!p-0 overflow-hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.extractRelativePath)(props === null || props === void 0 ? void 0 : (ref30 = props.fields) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.Image) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.value) === null || ref32 === void 0 ? void 0 : ref32.src),
                                    alt: ((ref52 = props === null || props === void 0 ? void 0 : (ref33 = props.fields) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.Image) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.value) === null || ref35 === void 0 ? void 0 : ref35.alt) !== null && ref52 !== void 0 ? ref52 : "").trim() || ((ref53 = props === null || props === void 0 ? void 0 : (ref36 = props.fields) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.Title) === null || ref37 === void 0 ? void 0 : ref37.value) !== null && ref53 !== void 0 ? ref53 : "").trim() || "Section image",
                                    width: 366,
                                    height: 160,
                                    layout: "responsive",
                                    objectFit: "fill",
                                    className: " animate-top-dga rounded-lg !min-w-full"
                                })
                            })
                        }),
                        (props === null || props === void 0 ? void 0 : (ref38 = props.fields) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.Description) === null || ref39 === void 0 ? void 0 : ref39.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                            id: "section-desc-" + (props === null || props === void 0 ? void 0 : props.SectionId),
                            field: props === null || props === void 0 ? void 0 : (ref40 = props.fields) === null || ref40 === void 0 ? void 0 : ref40.Description,
                            className: " animate-top-dga overflow-hidden text-neutral-800 text-lg font-normal w-full px-4 md:!px-0 break-words"
                        }),
                        renderableButtons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "animate-top-dga overflow-hidden flex flex-wrap w-full justify-start items-center gap-2 md:gap-4 p-4 pt-0 md:!p-0 mt-auto",
                            children: renderableButtons.map(function(btn, index) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                                var isFileDownload = Boolean(btn === null || btn === void 0 ? void 0 : (ref = btn.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.isFile) === null || ref1 === void 0 ? void 0 : ref1.value);
                                var rawFileSrc = isFileDownload ? resolveButtonRawFileSrc(btn) : "";
                                var downloadHref = rawFileSrc ? resolveDownloadHref(rawFileSrc) : "";
                                var fileName = rawFileSrc ? resolveButtonFileName(btn, rawFileSrc) : "";
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: isFileDownload ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: downloadHref || "#",
                                        download: fileName || undefined,
                                        target: "_self",
                                        rel: "noopener noreferrer",
                                        onClick: function(event) {
                                            if (!downloadHref) {
                                                event.preventDefault();
                                                return;
                                            }
                                            handleFileDownloadClick(event, fileName);
                                        },
                                        className: "inline-flex items-center gap-2 ".concat((btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "dga-primary-button" : "dga-secondary-button"),
                                        children: [
                                            btn === null || btn === void 0 ? void 0 : (ref2 = btn.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.BtnText) === null || ref3 === void 0 ? void 0 : ref3.value,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TemplateDownloadIcon__WEBPACK_IMPORTED_MODULE_7__.TemplateDownloadIcon, {
                                                variant: (btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "white" : "grey",
                                                size: 20
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_4__.Button, {
                                        text: btn === null || btn === void 0 ? void 0 : (ref4 = btn.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.BtnText) === null || ref5 === void 0 ? void 0 : ref5.value,
                                        redirect: (btn === null || btn === void 0 ? void 0 : (ref6 = btn.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.BtnUrl) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.href) || (btn === null || btn === void 0 ? void 0 : (ref9 = btn.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.BtnUrl) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : ref11.url),
                                        target: btn === null || btn === void 0 ? void 0 : (ref12 = btn.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.BtnUrl) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.value) === null || ref14 === void 0 ? void 0 : ref14.target,
                                        linktype: btn === null || btn === void 0 ? void 0 : (ref15 = btn.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.BtnUrl) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.linktype,
                                        classNames: "".concat((btn === null || btn === void 0 ? void 0 : btn.id) === (firstButtonWithLinkValue === null || firstButtonWithLinkValue === void 0 ? void 0 : firstButtonWithLinkValue.id) ? "dga-primary-button" : "dga-secondary-button", " !border-none !px-4 !py-2 !font-medium !text-base")
                                    })
                                }, (btn === null || btn === void 0 ? void 0 : btn.id) || index);
                            })
                        })
                    ]
                }),
                (props === null || props === void 0 ? void 0 : (ref41 = props.fields) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.Image) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.value) === null || ref43 === void 0 ? void 0 : ref43.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_responsive__WEBPACK_IMPORTED_MODULE_9___default()), {
                    minWidth: 768,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " overflow flex-1 relative md:min-h-max md:h-auto w-full p-4 rounded-2xl overflow-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.extractRelativePath)(props === null || props === void 0 ? void 0 : (ref44 = props.fields) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.Image) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.value) === null || ref46 === void 0 ? void 0 : ref46.src),
                            alt: ((ref54 = props === null || props === void 0 ? void 0 : (ref47 = props.fields) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.Image) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.value) === null || ref49 === void 0 ? void 0 : ref49.alt) !== null && ref54 !== void 0 ? ref54 : "").trim() || ((ref55 = props === null || props === void 0 ? void 0 : (ref50 = props.fields) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.Title) === null || ref51 === void 0 ? void 0 : ref51.value) !== null && ref55 !== void 0 ? ref55 : "").trim() || "Section image",
                            width: 605,
                            height: 362,
                            layout: "fill",
                            objectFit: "cover",
                            className: "rounded-lg min-w-full min-h-full animate-top-dga"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TitleDescriptionImage1));


/***/ }),

/***/ 72971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VotingCheckboxLabelsOptions": function() { return /* binding */ VotingCheckboxLabelsOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4145);


var VotingCheckboxLabelsOptions = function(param) {
    var options = param.options, selectedOptionIds = param.selectedOptionIds, onToggleOption = param.onToggleOption, sectionId = param.sectionId;
    if (!options.length) return null;
    var baseId = "".concat(sectionId, "-voting-labels").replace(/ /g, "-");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col gap-3",
        children: options.map(function(option) {
            var ref, ref1;
            var description = (ref = option.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Description) === null || ref1 === void 0 ? void 0 : ref1.value;
            if (!description) return null;
            var inputId = "".concat(baseId, "-").concat(option.id);
            var isSelected = selectedOptionIds.includes(option.id);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-2 p-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_1__.DGACheckboxInput, {
                        variant: "default",
                        size: "sm",
                        id: inputId,
                        checked: isSelected,
                        onChange: function() {
                            return onToggleOption(option.id);
                        },
                        "aria-label": description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: inputId,
                        className: "cursor-pointer text-sm text-primary-1000",
                        children: description
                    })
                ]
            }, option.id);
        })
    });
};


/***/ }),

/***/ 87708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VotingImageCardsOptions": function() { return /* binding */ VotingImageCardsOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90894);
/* harmony import */ var components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4145);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62009);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74627);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73165);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30706);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__);












var VotingImageCard = function(param) {
    var option = param.option, isSelected = param.isSelected, onSelect = param.onSelect;
    var _fields = option.fields, imageField = _fields.Image, Title = _fields.Title, Description = _fields.Description;
    var image = imageField === null || imageField === void 0 ? void 0 : imageField.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: "button",
        onClick: function() {
            return onSelect(option.id);
        },
        className: "flex w-full flex-col gap-6 rounded-2xl border bg-white p-4 text-start transition-colors ".concat(isSelected ? "border-primary-600" : "border-neutral-300"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-[250px] w-full shrink-0 overflow-hidden rounded-lg",
                children: [
                    (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                        src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(image.src),
                        alt: image.alt || (Title === null || Title === void 0 ? void 0 : Title.value) || "",
                        width: Number(image.width) || 403,
                        height: Number(image.height) || 250,
                        className: "h-full w-full object-cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-4 ltr:left-4 rtl:right-4 z-10",
                        onClick: function(event) {
                            return event.stopPropagation();
                        },
                        onKeyDown: function(event) {
                            return event.stopPropagation();
                        },
                        role: "presentation",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_3__.DGACheckboxInput, {
                            variant: "primary",
                            size: "sm",
                            checked: isSelected,
                            onChange: function() {
                                return onSelect(option.id);
                            },
                            "aria-label": Title === null || Title === void 0 ? void 0 : Title.value
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-lg font-bold text-neutral-800",
                        children: Title.value
                    }),
                    (Description === null || Description === void 0 ? void 0 : Description.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base text-neutral-800",
                        children: Description.value
                    })
                ]
            })
        ]
    });
};
var VotingImageCardsOptions = function(param) {
    var options = param.options, selectedOptionIds = param.selectedOptionIds, onToggleOption = param.onToggleOption, sectionId = param.sectionId;
    var baseId = "".concat(sectionId, "-voting-cards").replace(/ /g, "-");
    var paginationId = "".concat(baseId, "-pagination");
    var prevId = "".concat(baseId, "-prev");
    var nextId = "".concat(baseId, "-next");
    if (!options.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full max-w-full flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-3 mt-8 hidden w-fit gap-4 md:flex ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "mr-auto flex-row" : "ml-auto flex-row"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: prevId,
                        className: "[&.swiper-button-lock]:hidden [&.swiper-button-disabled_button]:bg-neutral-200 [&.swiper-button-disabled_button]:text-neutral-400 [&.swiper-button-disabled_button]:cursor-default",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_2__.DGACarouselArrow, {
                            direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "right" : "left",
                            onClick: function() {
                                return undefined;
                            },
                            size: "large",
                            style: "primary"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: nextId,
                        className: "[&.swiper-button-lock]:hidden [&.swiper-button-disabled_button]:bg-neutral-200 [&.swiper-button-disabled_button]:text-neutral-400 [&.swiper-button-disabled_button]:cursor-default",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_2__.DGACarouselArrow, {
                            direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "left" : "right",
                            onClick: function() {
                                return undefined;
                            },
                            size: "large",
                            style: "primary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "order-1 w-full max-w-full overflow-hidden ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "mr-[5%] md:mr-0" : "ml-[5%] md:ml-0"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                    className: "mySwiper w-full !overflow-hidden !p-[1px]",
                    watchOverflow: true,
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 24
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 32
                        }
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                        swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_7__/* .A11y */ .s5
                    ],
                    navigation: {
                        prevEl: "#".concat(prevId),
                        nextEl: "#".concat(nextId)
                    },
                    pagination: {
                        clickable: true,
                        el: "#".concat(paginationId)
                    },
                    freeMode: true,
                    a11y: {
                        enabled: true,
                        paginationBulletMessage: "Go to slide {{index}}"
                    },
                    dir: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "rtl" : "ltr",
                    onSwiper: function(swiper) {
                        swiper.navigation.init();
                        swiper.navigation.update();
                    },
                    children: options.map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                            className: "!h-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VotingImageCard, {
                                option: option,
                                isSelected: selectedOptionIds.includes(option.id),
                                onSelect: onToggleOption
                            })
                        }, option.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: paginationId,
                className: "custom_swiper order-2 !mt-8 mx-auto !justify-center md:hidden"
            })
        ]
    });
};


/***/ }),

/***/ 60509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VotingOptions": function() { return /* binding */ VotingOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91526);
/* harmony import */ var _VotingCheckboxLabelsOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72971);
/* harmony import */ var _VotingImageCardsOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87708);
/* harmony import */ var _VotingPoolButtonsOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64501);
/* harmony import */ var _VotingRadioButtonsOptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40452);






var VotingOptions = function(param) {
    var layout = param.layout, options = param.options, selectedOptionIds = param.selectedOptionIds, onToggleOption = param.onToggleOption, onSelectOption = param.onSelectOption, sectionId = param.sectionId, votingOptionsTitle = param.votingOptionsTitle, _pollCounts = param.pollCounts, pollCounts = _pollCounts === void 0 ? {} : _pollCounts;
    switch(layout){
        case _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_1__.VOTING_LAYOUT.IMAGE_CARDS:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VotingImageCardsOptions__WEBPACK_IMPORTED_MODULE_3__.VotingImageCardsOptions, {
                options: options,
                selectedOptionIds: selectedOptionIds,
                onToggleOption: onToggleOption,
                sectionId: sectionId
            });
        case _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_1__.VOTING_LAYOUT.CHECKBOX_LABELS:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VotingCheckboxLabelsOptions__WEBPACK_IMPORTED_MODULE_2__.VotingCheckboxLabelsOptions, {
                options: options,
                selectedOptionIds: selectedOptionIds,
                onToggleOption: onToggleOption,
                sectionId: sectionId
            });
        case _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_1__.VOTING_LAYOUT.RADIO_BUTTONS:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VotingRadioButtonsOptions__WEBPACK_IMPORTED_MODULE_5__.VotingRadioButtonsOptions, {
                options: options,
                selectedOptionIds: selectedOptionIds,
                onSelectOption: onSelectOption,
                sectionId: sectionId,
                votingOptionsTitle: votingOptionsTitle
            });
        case _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_1__.VOTING_LAYOUT.POOL_BUTTONS:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VotingPoolButtonsOptions__WEBPACK_IMPORTED_MODULE_4__.VotingPoolButtonsOptions, {
                options: options,
                selectedOptionIds: selectedOptionIds,
                onToggleOption: onToggleOption,
                pollCounts: pollCounts
            });
        default:
            return null;
    }
};


/***/ }),

/***/ 64501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VotingPoolButtonsOptions": function() { return /* binding */ VotingPoolButtonsOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getBarWidthPercent = function(count, totalCount) {
    if (totalCount <= 0 || count <= 0) return 0;
    return count / totalCount * 100;
};
var VotingPoolButtonsOptions = function(param) {
    var options = param.options, selectedOptionIds = param.selectedOptionIds, onToggleOption = param.onToggleOption, pollCounts = param.pollCounts;
    if (!options.length) return null;
    var _id;
    var counts = options.map(function(option) {
        return (_id = pollCounts[option.id]) !== null && _id !== void 0 ? _id : 0;
    });
    var totalVoteCount = counts.reduce(function(sum, count) {
        return sum + count;
    }, 0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col gap-6",
        children: options.map(function(option) {
            var ref, ref1;
            var description = (ref = option.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Description) === null || ref1 === void 0 ? void 0 : ref1.value;
            if (!description) return null;
            var _id;
            var voteCount = (_id = pollCounts[option.id]) !== null && _id !== void 0 ? _id : 0;
            var isSelected = selectedOptionIds.includes(option.id);
            var barWidth = getBarWidthPercent(voteCount, totalVoteCount);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                onClick: function() {
                    return onToggleOption(option.id);
                },
                "aria-pressed": isSelected,
                className: "relative w-full overflow-hidden rounded-xl bg-[#F3F4F6] text-start transition-shadow ".concat(isSelected ? "ring-2 ring-primary-600 ring-offset-2" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-y-0 start-0 rounded-s-xl bg-[#B8EACB]",
                        style: {
                            width: "".concat(barWidth, "%")
                        },
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative flex items-center justify-between gap-4 px-5 py-3.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-base font-medium text-[#161616]",
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "shrink-0 text-base font-medium text-[#161616]",
                                children: voteCount
                            })
                        ]
                    })
                ]
            }, option.id);
        })
    });
};


/***/ }),

/***/ 40452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VotingRadioButtonsOptions": function() { return /* binding */ VotingRadioButtonsOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_dga_radio_input_DGARadioInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13917);


var VotingRadioButtonsOptions = function(param) {
    var options = param.options, selectedOptionIds = param.selectedOptionIds, onSelectOption = param.onSelectOption, sectionId = param.sectionId, votingOptionsTitle = param.votingOptionsTitle;
    if (!options.length) return null;
    var baseId = "".concat(sectionId, "-voting-radios").replace(/ /g, "-");
    var groupName = "".concat(baseId, "-group");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-5 px-2 py-4",
        children: [
            votingOptionsTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm font-semibold text-primary-1000",
                children: votingOptionsTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col gap-3",
                children: options.map(function(option) {
                    var ref, ref1;
                    var description = (ref = option.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Description) === null || ref1 === void 0 ? void 0 : ref1.value;
                    if (!description) return null;
                    var inputId = "".concat(baseId, "-").concat(option.id);
                    var isSelected = selectedOptionIds.includes(option.id);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_radio_input_DGARadioInput__WEBPACK_IMPORTED_MODULE_1__.DGARadioInput, {
                                variant: "primary",
                                size: "md",
                                id: inputId,
                                name: groupName,
                                checked: isSelected,
                                onChange: function() {
                                    return onSelectOption(option.id);
                                },
                                "aria-label": description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: inputId,
                                className: "cursor-pointer text-sm text-primary-1000",
                                children: description
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
};


/***/ }),

/***/ 91526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VOTING_LAYOUT": function() { return /* binding */ VOTING_LAYOUT; },
/* harmony export */   "fetchVotingPollCounts": function() { return /* binding */ fetchVotingPollCounts; },
/* harmony export */   "formatSitecoreGuid": function() { return /* binding */ formatSitecoreGuid; },
/* harmony export */   "formatVotingSectionDate": function() { return /* binding */ formatVotingSectionDate; },
/* harmony export */   "getVotingSectionLayoutKey": function() { return /* binding */ getVotingSectionLayoutKey; },
/* harmony export */   "isPoolButtonsLayout": function() { return /* binding */ isPoolButtonsLayout; },
/* harmony export */   "isVotingSection": function() { return /* binding */ isVotingSection; },
/* harmony export */   "resolveVotingPollCountsForTemplate": function() { return /* binding */ resolveVotingPollCountsForTemplate; },
/* harmony export */   "submitVote": function() { return /* binding */ submitVote; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56440);
/* harmony import */ var moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ar_ly__WEBPACK_IMPORTED_MODULE_2__);


var ref;



// --- Layout constants ---
var VOTING_LAYOUT = {
    IMAGE_CARDS: "ImageCards",
    CHECKBOX_LABELS: "CheckboxLabels",
    RADIO_BUTTONS: "RadioButtons",
    POOL_BUTTONS: "PoolButtons"
};
var EMPTY_DATE = "0001-01-01T00:00:00Z";
var ref1;
var SITECORE_REST_BASE = (ref1 = (ref = "https://c-admin.takamulstg.com") === null || ref === void 0 ? void 0 : ref.trim()) !== null && ref1 !== void 0 ? ref1 : "";
var SUBMIT_VOTE_ENDPOINT = "".concat(SITECORE_REST_BASE, "/api/Vote/Submit");
var GET_OPTIONS_COUNT_ENDPOINT = "".concat(SITECORE_REST_BASE, "/api/Vote/GetOptionsCount");
var formatSitecoreGuid = function(id) {
    if (!id) return "";
    var clean = id.replace(/[{}]/g, "").trim();
    if (!clean) return "";
    return "{".concat(clean.toUpperCase(), "}");
};
var ref2;
var normalizeGuid = function(id) {
    return (ref2 = id === null || id === void 0 ? void 0 : id.replace(/[{}]/g, "").trim().toUpperCase()) !== null && ref2 !== void 0 ? ref2 : "";
};
var formatOptionIdForVoteApi = function(id) {
    return normalizeGuid(id);
};
var getVotingSectionLayoutKey = function(fields) {
    var ref, ref1, ref2;
    return fields === null || fields === void 0 ? void 0 : (ref = fields.VotingSectionLayout) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Title) === null || ref2 === void 0 ? void 0 : ref2.value;
};
var isPoolButtonsLayout = function(layoutKey) {
    return layoutKey === VOTING_LAYOUT.POOL_BUTTONS;
};
var isVotingSection = function(section) {
    var ref, ref1, ref2, ref3;
    return (section === null || section === void 0 ? void 0 : (ref = section.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.SectionTemplate) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Title) === null || ref3 === void 0 ? void 0 : ref3.value) === "VotingSection";
};
var fetchVotingPollCounts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(optionIds, fallbackCounts) {
        var zeroCounts, fallback, data, _TotalVoteCount, countsByNormalizedId, ref, error, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    zeroCounts = Object.fromEntries(optionIds.map(function(id) {
                        return [
                            id,
                            0
                        ];
                    }));
                    fallback = fallbackCounts !== null && fallbackCounts !== void 0 ? fallbackCounts : zeroCounts;
                    if (!optionIds.length || !SITECORE_REST_BASE) {
                        return [
                            2,
                            fallback
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post(GET_OPTIONS_COUNT_ENDPOINT, {
                            optionsId: optionIds.map(formatOptionIdForVoteApi).filter(Boolean)
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 2:
                    data = _state.sent().data;
                    if (!Array.isArray(data)) {
                        return [
                            2,
                            fallback
                        ];
                    }
                    countsByNormalizedId = Object.fromEntries(data.map(function(item) {
                        return [
                            normalizeGuid(item.OptionId),
                            (_TotalVoteCount = item.TotalVoteCount) !== null && _TotalVoteCount !== void 0 ? _TotalVoteCount : 0
                        ];
                    }));
                    return [
                        2,
                        Object.fromEntries(optionIds.map(function(id) {
                            return [
                                id,
                                (ref = countsByNormalizedId[normalizeGuid(id)]) !== null && ref !== void 0 ? ref : 0
                            ];
                        }))
                    ];
                case 3:
                    error = _state.sent();
                    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
                        ;
                        console.error("GetOptionsCount error:", ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.data) || error.message);
                    }
                    return [
                        2,
                        fallback
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchVotingPollCounts(optionIds, fallbackCounts) {
        return _ref.apply(this, arguments);
    };
}();
var resolveVotingPollCountsForTemplate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(templateSections) {
        var pollCountsBySection;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(templateSections === null || templateSections === void 0 ? void 0 : templateSections.length)) return [
                        2,
                        {}
                    ];
                    pollCountsBySection = {};
                    return [
                        4,
                        Promise.all(templateSections.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(section) {
                                var ref, ref1, optionIds, _;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!isVotingSection(section) || !isPoolButtonsLayout(getVotingSectionLayoutKey(section.fields))) {
                                                return [
                                                    2
                                                ];
                                            }
                                            optionIds = ((ref1 = (ref = section.fields) === null || ref === void 0 ? void 0 : ref.VotingOptions) !== null && ref1 !== void 0 ? ref1 : []).map(function(option) {
                                                return option.id;
                                            }).filter(Boolean);
                                            if (!optionIds.length) return [
                                                2
                                            ];
                                            _ = section.id;
                                            return [
                                                4,
                                                fetchVotingPollCounts(optionIds)
                                            ];
                                        case 1:
                                            pollCountsBySection[_] = _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(section) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        pollCountsBySection
                    ];
            }
        });
    });
    return function resolveVotingPollCountsForTemplate(templateSections) {
        return _ref.apply(this, arguments);
    };
}();
var formatVotingSectionDate = function(dateValue, locale) {
    if (!dateValue || dateValue === EMPTY_DATE || !moment__WEBPACK_IMPORTED_MODULE_1___default()(dateValue).isValid()) {
        return null;
    }
    var momentLocale = locale === "ar" ? "ar-ly" : locale || "en";
    var parsed = moment__WEBPACK_IMPORTED_MODULE_1___default()(dateValue).locale(momentLocale);
    return {
        datePart: parsed.format(locale === "ar" ? "D MMMM YYYY" : "MMMM D, YYYY"),
        timePart: parsed.format("h:mmA")
    };
};
var submitVote = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var pageId, pageName, voteIds, language, _commission, commission, captchaResponse;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            pageId = param.pageId, pageName = param.pageName, voteIds = param.voteIds, language = param.language, _commission = param.commission, commission = _commission === void 0 ? "moc" : _commission, captchaResponse = param.captchaResponse;
            return [
                2,
                axios__WEBPACK_IMPORTED_MODULE_0___default().post(SUBMIT_VOTE_ENDPOINT, {
                    pageId: formatSitecoreGuid(pageId),
                    pageName: pageName,
                    voteIds: voteIds.map(formatSitecoreGuid).filter(Boolean),
                    language: language,
                    commission: commission,
                    captchaResponse: captchaResponse
                }, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
            ];
        });
    });
    return function submitVote(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 66472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63651);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lib_toast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88516);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92413);
/* harmony import */ var _Components_VotingOptions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60509);
/* harmony import */ var _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91526);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 













var VotingSection = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var fields = props.fields, locale = props.locale, SectionId = props.SectionId, pageMetaData = props.pageMetaData, pollCounts = props.pollCounts;
    var ref26;
    var votingOptions = (ref26 = fields === null || fields === void 0 ? void 0 : fields.VotingOptions) !== null && ref26 !== void 0 ? ref26 : [];
    var layoutKey = (fields === null || fields === void 0 ? void 0 : (ref = fields.VotingSectionLayout) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Title) === null || ref2 === void 0 ? void 0 : ref2.value) || _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__.VOTING_LAYOUT.IMAGE_CARDS;
    var isPoolButtonsLayout = layoutKey === _Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__.VOTING_LAYOUT.POOL_BUTTONS;
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), selectedOptionIds = ref27[0], setSelectedOptionIds = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(pollCounts !== null && pollCounts !== void 0 ? pollCounts : {}), pollCountsState = ref28[0], setPollCountsState = ref28[1];
    var ref29 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), captcha = ref29[0], setCaptcha = ref29[1];
    var ref30 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), captchaError = ref30[0], setCaptchaError = ref30[1];
    var ref31 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isLoading = ref31[0], setIsLoading = ref31[1];
    var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var sitekey = "6LfTSI4jAAAAAI41yLanFCkt2HaGfgD1jdCBZuac" || 0;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setPollCountsState(pollCounts !== null && pollCounts !== void 0 ? pollCounts : {});
    }, [
        pollCounts
    ]);
    var successToastTitle = (fields === null || fields === void 0 ? void 0 : (ref3 = fields.SuccessToastTitle) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.trim()) || (locale === "ar" ? "تم إرسال تصويتك بنجاح." : "Your vote was submitted successfully.");
    var successToastDescription = fields === null || fields === void 0 ? void 0 : (ref5 = fields.SuccessToastDescription) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.value) === null || ref6 === void 0 ? void 0 : ref6.trim();
    var errorToastTitle = (fields === null || fields === void 0 ? void 0 : (ref7 = fields.ErrorToastTitle) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.trim()) || (locale === "ar" ? "حدث خطأ ما. يرجى المحاولة مرة أخرى." : "Something went wrong. Please try again.");
    var errorToastDescription = fields === null || fields === void 0 ? void 0 : (ref9 = fields.ErrorToastDescription) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.value) === null || ref10 === void 0 ? void 0 : ref10.trim();
    var cmsSectionBg = fields === null || fields === void 0 ? void 0 : (ref11 = fields.SectionBackgroundColor) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.value) === null || ref12 === void 0 ? void 0 : ref12.trim();
    var formattedDate = (0,_Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__.formatVotingSectionDate)(fields === null || fields === void 0 ? void 0 : (ref13 = fields.Date) === null || ref13 === void 0 ? void 0 : ref13.value, locale);
    var hasHeaderContent = (fields === null || fields === void 0 ? void 0 : (ref14 = fields.Title) === null || ref14 === void 0 ? void 0 : ref14.value) || (fields === null || fields === void 0 ? void 0 : (ref15 = fields.SubTitle) === null || ref15 === void 0 ? void 0 : ref15.value) || (fields === null || fields === void 0 ? void 0 : (ref16 = fields.Description) === null || ref16 === void 0 ? void 0 : ref16.value) || formattedDate;
    if (!hasHeaderContent && !votingOptions.length) {
        return null;
    }
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(event) {
            var ref, ref1, ref2, ref3, pageName, ref4, optionIds, updatedCounts, error, ref5, ref6;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setCaptchaError(false);
                        if (!selectedOptionIds.length) {
                            return [
                                2
                            ];
                        }
                        if (!captcha) {
                            setCaptchaError(true);
                            return [
                                2
                            ];
                        }
                        pageName = (pageMetaData === null || pageMetaData === void 0 ? void 0 : (ref = pageMetaData.pageTitle) === null || ref === void 0 ? void 0 : ref.value) || ((ref3 = (ref2 = pageMetaData === null || pageMetaData === void 0 ? void 0 : (ref1 = pageMetaData.itemPath) === null || ref1 === void 0 ? void 0 : ref1.split("/")) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean)) === null || ref3 === void 0 ? void 0 : ref3.pop()) || "";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            (0,_Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__.submitVote)({
                                pageId: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.itemId,
                                pageName: pageName,
                                voteIds: selectedOptionIds,
                                language: locale,
                                captchaResponse: captcha
                            })
                        ];
                    case 2:
                        _state.sent();
                        (0,lib_toast__WEBPACK_IMPORTED_MODULE_5__/* .showSuccessToast */ .X)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                            title: successToastTitle
                        }, successToastDescription ? {
                            description: successToastDescription
                        } : {}));
                        setSelectedOptionIds([]);
                        setCaptcha(null);
                        (ref4 = recaptchaRef.current) === null || ref4 === void 0 ? void 0 : ref4.reset();
                        if (!isPoolButtonsLayout) return [
                            3,
                            4
                        ];
                        optionIds = votingOptions.map(function(option) {
                            return option.id;
                        }).filter(Boolean);
                        if (!optionIds.length) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,_Helpers_VotingSectionHelpers__WEBPACK_IMPORTED_MODULE_9__.fetchVotingPollCounts)(optionIds, pollCountsState)
                        ];
                    case 3:
                        updatedCounts = _state.sent();
                        setPollCountsState(updatedCounts);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        error = _state.sent();
                        setCaptcha(null);
                        (ref5 = recaptchaRef.current) === null || ref5 === void 0 ? void 0 : ref5.reset();
                        if (axios__WEBPACK_IMPORTED_MODULE_3___default().isAxiosError(error)) {
                            ;
                            console.error("Vote submit error:", ((ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.data) || error.message);
                        }
                        (0,lib_toast__WEBPACK_IMPORTED_MODULE_5__/* .showErrorToast */ .E)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                            title: errorToastTitle
                        }, errorToastDescription ? {
                            description: errorToastDescription
                        } : {}));
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        id: SectionId,
        className: "py-10 ".concat(locale === "ar" ? "rtl" : ""),
        style: cmsSectionBg ? {
            backgroundColor: cmsSectionBg
        } : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: handleSubmit,
            className: "responsive flex flex-col gap-6",
            children: [
                hasHeaderContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-6",
                    children: [
                        (fields === null || fields === void 0 ? void 0 : (ref17 = fields.Title) === null || ref17 === void 0 ? void 0 : ref17.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-[30px] font-bold leading-[38px] text-primary-1000",
                            children: fields.Title.value
                        }),
                        ((fields === null || fields === void 0 ? void 0 : (ref18 = fields.SubTitle) === null || ref18 === void 0 ? void 0 : ref18.value) || (fields === null || fields === void 0 ? void 0 : (ref19 = fields.Description) === null || ref19 === void 0 ? void 0 : ref19.value) || formattedDate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                (fields === null || fields === void 0 ? void 0 : (ref20 = fields.SubTitle) === null || ref20 === void 0 ? void 0 : ref20.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[21px] font-semibold text-primary-1000",
                                    children: fields.SubTitle.value
                                }),
                                (fields === null || fields === void 0 ? void 0 : (ref21 = fields.Description) === null || ref21 === void 0 ? void 0 : ref21.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[15px] leading-[23px] text-primary-1000",
                                    children: fields.Description.value
                                }),
                                formattedDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-1 text-[15px] text-neutral-500",
                                    children: [
                                        (fields === null || fields === void 0 ? void 0 : (ref22 = fields.CalendarIcon) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.value) === null || ref23 === void 0 ? void 0 : ref23.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(fields.CalendarIcon.value.src),
                                            alt: fields.CalendarIcon.value.alt || "",
                                            width: 14,
                                            height: 14,
                                            className: "shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: formattedDate.datePart
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: "."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "!ltr",
                                            children: formattedDate.timePart
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                votingOptions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Components_VotingOptions__WEBPACK_IMPORTED_MODULE_8__.VotingOptions, {
                    layout: layoutKey,
                    options: votingOptions,
                    selectedOptionIds: selectedOptionIds,
                    onToggleOption: function(optionId) {
                        return setSelectedOptionIds(function(prev) {
                            return prev.includes(optionId) ? prev.filter(function(id) {
                                return id !== optionId;
                            }) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(prev).concat([
                                optionId
                            ]);
                        });
                    },
                    onSelectOption: function(optionId) {
                        return setSelectedOptionIds([
                            optionId
                        ]);
                    },
                    sectionId: SectionId,
                    votingOptionsTitle: fields === null || fields === void 0 ? void 0 : (ref24 = fields.VotingOptionsTitle) === null || ref24 === void 0 ? void 0 : ref24.value,
                    pollCounts: pollCountsState
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full max-w-[388px] items-start ".concat(captchaError ? "rounded border-2 border-red-500 p-1" : ""),
                    children: sitekey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        ref: recaptchaRef,
                        sitekey: sitekey,
                        onChange: function(value) {
                            setCaptcha(value);
                            if (value) setCaptchaError(false);
                        },
                        hl: locale
                    })
                }),
                (fields === null || fields === void 0 ? void 0 : (ref25 = fields.SubmitButtonText) === null || ref25 === void 0 ? void 0 : ref25.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_2__.DGAButton, {
                    type: "submit",
                    buttonContent: fields.SubmitButtonText.value,
                    disabled: isLoading || !selectedOptionIds.length || !captcha,
                    size: "lg",
                    variant: "primary"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VotingSection);


/***/ })

}]);